export const MOBILE = [
    {
        id: 5,
        name: "Food Finder App",
        src: "images/Food-Finder.png",
        alt: "screenshot of FF next.js project",
        desc: "This project was co-created with Warren Savage. This project uses Next.js on the frontend. The api backend is data from a Google sheet. The Apps Script sets up a basic api which allows access to the data on the Google Sheet.",
        link: "https://food-find-jgilday01s-projects.vercel.app",
        btnTxt: "Visit the Site"
    },
];
